export default __webpack_public_path__ + "static/study-support-dfb0d90887b7f70f37acb474cbb62d69.png";